<style scoped>
.chart-block {
    width: 100%;
}

.loader-block {
    padding: 150px 0;
}

.aquazor-no-data {
    text-align: center;
    margin-top: 100px;
    color: #526170;
}

.faucet-colors {
    border-right: 1px solid #526170;
}

.sensor-norm-info-color {
    background-color: #298f01;
}

.rect_has_data-2 {
    background-color: rgb(88, 216, 255);
}

.closed-process-info-color {
    background-color: rgb(28, 74, 88);
}

.closed-info-color {
    background-color: rgb(90, 90, 90)
}

.open-process-info-color {
    background-color: rgb(88, 216, 255);
}

.faucet-error-info-color {
    background-color: rgb(255, 115, 0);
}

.open-info-color {
    background-color: rgb(171, 235, 255);
}

.sensor-alert-info-color {
    background-color: rgb(255, 58, 107);
}

.color-info .color-info-block {
    display: inline-block;
}

.color-info .color-info-block div,
.color-info .color-info-block p {
    display: inline-block;
    color: #74899e;
}

.color-info .color-info-block div  {
    width: 15px;
    height: 15px;
    margin: 0 5px;
    position: relative;
    top: 2px;
}

.color-info .color-info-block  {
    margin: 0 5px;
}
</style>

<template>
<div ref="chart_block" class="chart-block">
    <p id="sensors-chart"></p>
    <div class="col-12 aquazor-no-data" v-if="this.dataset.length == 0 && !loader">
        <p>Нет данных</p>
    </div>
    <div class="loader-block" v-if="loader">
        <loader-component></loader-component>
    </div>
    <div class="color-info row">
        <div class="col-6 faucet-colors">
            <div class="color-info-block">
                <div class="open-info-color"></div><p> - кран открыт</p>
            </div>
            <div class="color-info-block">
                <div class="closed-process-info-color"></div><p> - кран закрыт</p>
            </div>
            <div class="color-info-block">
                <div class="faucet-error-info-color"></div><p> - кран в ошибке</p>
            </div>
        </div>
        <div class="col-6 sensor-colors">
            <div class="color-info-block">
                <div class="sensor-norm-info-color"></div><p> - датчик в норме</p>
            </div>
            <div class="color-info-block">
                <div class="sensor-alert-info-color"></div><p> - датчик в тревоге</p>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import * as d3 from 'd3'
import '@/assets/css/history_chart.css'
import history_chart from '@/assets/js/history_chart.js'
import instruments from '@/assets/js/instruments.js'
import axios from 'axios'
import config from '@/config.js'
import loader from './loader.vue'

export default {
    name: 'vue-line-chart',
    created() {
        get_for_chart(this)
    },
    components: {
        'loader-component': loader,
    },
    data() {
        return {
            loader: true,
            chart: null,
            dataset: []
        };
    },
    mounted() {

    },
    methods: {
        timeChart() {
            try {
                var start_date = getFormattedDate(this.data.start_time)
                var end_date = getFormattedDate(this.data.end_time)
                console.log(start_date)
                var chart_block = this.$refs.chart_block
                var parseDate = d3.time.format('%Y-%m-%d %H:%M:%S');
                var chart = history_chart().width(chart_block.clientWidth)
                    .offset_time(this.data.offset_time)
                    .displayDateRange([
                        parseDate.parse(start_date),
                        parseDate.parse(end_date)
                    ])

                d3.select("#sensors-chart")
                    .datum(this.dataset)
                    .call(chart)
                this.chart = chart
                this.loader = false
            } catch (error) {
                console.log(error)
            }

        }
    },
    beforeDestroy() {
        d3.select("#sensors-chart").remove()
        this.chart.clean()
    },
    props: ['data']
}

function get_for_chart(vue_obj) {
    if (!!localStorage.token) {
        console.log(vue_obj.data)
        var post_data = new FormData()
        post_data.set('token', localStorage.token)
        post_data.set('sensors', vue_obj.data.sensors)
        post_data.set('faucets', vue_obj.data.faucets)
        post_data.set('period_start', vue_obj.data.start_time)
        post_data.set('period_end', vue_obj.data.end_time)
        post_data.set('id_group', vue_obj.$route.params.id_group)
        axios({
                method: 'POST',
                url: config.API_HOST + '/groups/get_for_chart',
                data: post_data
            })
            .then(function (response) {
                console.log(response)
                vue_obj.dataset = []
                if (response.data.faucets) {
                    response.data.faucets.forEach(faucet_data => {
                        var data_for_chart = new Array()
                        faucet_data.data.forEach(faucet_data_element => {
                            if (faucet_data_element[1] == 1) {
                                faucet_data_element[1] = 7
                            }
                            data_for_chart.push(faucet_data_element)
                        });
                        vue_obj.dataset.push({
                            "measure": faucet_data.name,
                            "data": data_for_chart
                        })
                        if (vue_obj.dataset.length == 0) {
                            this.loader = false
                        }
                    })
                }
                if (response.data.sensors) {
                    response.data.sensors.forEach(sensor_data => {
                        vue_obj.dataset.push({
                            "measure": sensor_data.name,
                            "data": sensor_data.data
                        })
                    })
                }
                if (response.data.offset_time) {
                    vue_obj.offset_time = response.data.offset_time
                }
                vue_obj.timeChart()
            })
            .catch(function (error) {
                console.log(error.response)
                // get_for_chart(vue_obj)
            })
    }
}

function getFormattedDate(timestamp) {
    var date = new Date();
    date.setTime(timestamp)
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var hour = date.getHours();
    var min = date.getMinutes();
    var sec = date.getSeconds();

    month = (month < 10 ? "0" : "") + month;
    day = (day < 10 ? "0" : "") + day;
    hour = (hour < 10 ? "0" : "") + hour;
    min = (min < 10 ? "0" : "") + min;
    sec = (sec < 10 ? "0" : "") + sec;

    var str = date.getFullYear() + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec;

    return str;
}
</script>



// WEBPACK FOOTER //
// src/components/elements/history_chart.vue